// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"394":"fca9bc94","623":"9db880b2"}[chunkId] + ".css";
};